import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Input from '@rad/components/inputs/input';
import Dropdown from '@rad/components/inputs/dropdown';
import CheckSwitch from '@rad/components/inputs/checkswitch';
import ActionMenu from '@rad/components/ui/action-menu';
import createTable from '@rad/components/ui/table';
import { useFetch, useRouting, useUpdateEffect } from '@rad/hooks';
import SystemLayout from '../_layout';
import { systemRoutes } from '../../../common/routes/system';
import { getGlobalUsers, fetchCommunities } from '../../../common/network/system';
import { withAllOption } from '@rad/utility/promise';
import { displayDate } from '@rad/utility/formatting';
const SystemUsersIndex = () => {
    const [, navigate] = useRouting();
    const [search, setSearch] = React.useState('');
    const [selectedDistrict, setSelectedDistrict] = React.useState(null);
    const [showDisabled, setShowDisabled] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(20);
    const [sort, setSort] = React.useState({ field: 'lastName', direction: 'asc' });
    const [communitiesPromise] = useFetch(fetchCommunities);
    const [usersPromise, usersReload] = useFetch(getGlobalUsers({
        sortBy: sort.field + ':' + sort.direction,
        search,
        page,
        pageSize,
        district_id: selectedDistrict || '',
        hideDisabled: !showDisabled,
    }));
    const UsersTable = createTable(usersPromise);
    useUpdateEffect(usersReload, [search, selectedDistrict, showDisabled, page, pageSize, sort]);
    useUpdateEffect(() => setPage(1), [search, selectedDistrict, showDisabled, pageSize, sort]);
    return (_jsxs(SystemLayout, { title: "Users", active: "users", children: [_jsxs("div", { className: "d-flex flex-wrap align-items-center gap-2 mb-3", children: [_jsx(Input, { label: "Search", kind: "text", size: "md", className: "w-25", value: search, onChange: setSearch }), _jsx(Dropdown, { options: withAllOption(communitiesPromise, { key: 'id', labelKey: 'title', allLabel: 'All Communities' }), optionKey: (opt) => opt.id, optionLabel: (opt) => opt.title, value: selectedDistrict, onChange: setSelectedDistrict, label: "Community", className: "w-15" }), _jsx(CheckSwitch, { switch: true, label: "Show Disabled", value: showDisabled, onChange: setShowDisabled })] }), _jsx(UsersTable, { onRowClick: ({ id }) => navigate(systemRoutes.usersDetail.getURL({ id })), onPageChange: setPage, onPageSizeChange: setPageSize, pageSizeOptions: [10, 20, 50], sort: sort, onSortChange: setSort, columns: [
                    {
                        header: 'User', sortField: 'lastName', render: ({ firstName, lastName, email, deleted }) => (_jsxs("div", { children: [_jsxs("div", { className: "fw-semibold", children: [firstName, " ", lastName, !deleted ? null : _jsxs("span", { className: "badge bg-danger ms-2", children: ["Deactivated ", displayDate(deleted)] })] }), _jsx("div", { className: "text-muted small", children: email })] }))
                    },
                    {
                        header: 'Districts', render: ({ districts }) => (_jsx(_Fragment, { children: districts.map((d, i) => _jsx("span", { className: "badge bg-secondary me-1", children: d }, i)) }))
                    },
                    {
                        header: 'Last Login', render: ({ lastLoggedIn }) => (_jsx(_Fragment, { children: displayDate(lastLoggedIn) || '—' }))
                    },
                    {
                        header: '', render: (user) => (_jsx("div", { onClick: e => e.stopPropagation(), children: _jsx(ActionMenu, { render: _jsx("i", { className: "bi bi-three-dots-vertical" }), children: _jsx(ActionMenu.Item, { onClick: () => navigate(systemRoutes.usersDetail.getURL({ id: user.id })), children: "View Details" }) }) }))
                    },
                ] })] }));
};
export default SystemUsersIndex;
